import axios from 'axios';
import config from '../config/config';
import {
    SUPPORTER_EMERGENCY_CONTACT_REQUEST,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE,
    SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE,
    SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR,
    SUPPORTER_EMERGENCY_CONTACT_EDIT
} from '../config/actions';

export function getEmergencyContact(id) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_EMERGENCY_CONTACT_REQUEST
        });
        axios(config.server.endpoint + 'backend/supporter/emergencyContact/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: SUPPORTER_EMERGENCY_CONTACT_RECEIVE,
                    data: response.data
                });
            }
        })
    }
}

export function changeValue(name, value) {
    return {
        type: SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE,
        name,
        value
    }
}

export function editEmergencyContact() {
    return {
        type: SUPPORTER_EMERGENCY_CONTACT_EDIT
    }
}

export function saveEmergencyContact(data) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE
        });
        axios(config.server.endpoint + 'backend/supporter/emergencyContact/' + data.id, {
            method: 'put',
            data: {
                lastname: data.lastname,
                firstname: data.firstname,
                phone: data.phone,
                type: data.type,
                availableTypes: data.availableTypes
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE,
                        data: response.data
                    });
                } else {
                    dispatch({
                        type: SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR,
                        data: response.data
                    });
                }
            }
        });
    }
}